import {
  doGet,
  doPost,
} from '@/http/index.js';
import axios from 'axios';

const actions = {
  getMessages: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/get-messages',
        method: 'GET',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  newMessageAvailable: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/check-messages',
        method: 'GET',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
};

export default {
  namespaced: true,
  actions,
};
